
<template>
  <div class="content">
    <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
     <div>
        <router-link :to="{ path: '/allnews'}">
          <button type="submit" class="btn btn-info  btn-sm px-3 mr-3">Haberler</button>
        </router-link>
        <router-link :to="{ path: '/allnews-order'}">
          <button type="submit" class="btn btn-warning active text-white btn-sm px-3 mr-3">Haber Sıralaması</button>
        </router-link>

      </div>
      <span></span>
    </div>
    <card>
      <div class="row">
        <div class="col-12 col-md-12" v-if="!err">
          <div class="card">
            <div class="card-body">
              <h5>
                Haberleri Sırala
                <small
                  class="text-info"
                >Haberlerin sıralamasını değiştirmek için sürükleyin.</small>
              </h5>
              <draggable v-model="sliderItems" :options="{animation:200}" @update="update()">
                <transition-group>
                  <div v-for="item in sliderItems" :key="item.id">
                    <div class="card mb-2 menu-item">
                      <div class="card-body row">
                        <div class="col-12 d-flex align-items-center">{{item.post.name}}( Kategori Adı - {{item.post.category.name}} )</div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
        <div v-if="err">
          {{err}}
        </div>
      </div>
      <b-modal id="croppieModal" hide-footer size="lg" title="Resim Seç">
        <p
          class="text-danger mb-0"
        >Genişlik(277) Yükseklik(244). PNG ve arkası şeffaf olacak şekilde</p>
        <input name="myFile" id="myImage" class="m-3" type="file" @change="bind()" />

        <vue-croppie
          :enable-resize="false"
          :viewport="{width: 277, height: 244, type: 'suare'}"
          :boundary="{width: 400, height: 400}"
          ref="main"
          :enableOrientation="true"
          @result="result"
        ></vue-croppie>
        <b-btn class="mt-3" variant="danger btn-fill" @click="hideCroppieModal()">İptal</b-btn>
        <b-btn
          class="mt-3"
          id="submit-image"
          variant="success btn-fill float-right"
          @click="changeButtonText()"
        >Kaydet</b-btn>
      </b-modal>
    </card>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import { ModelSelect } from "vue-search-select";

export default {
  data: function() {
    return {
      featuredTitles: [
        {
          key: "bellow_slider_1",
          title: null,
          details: null,
          link: null,
          image: null
        },
        {
          key: "bellow_slider_2",
          title: null,
          details: null,
          link: null,
          image: null
        },
        {
          key: "bellow_slider_3",
          title: null,
          details: null,
          link: null,
          image: null
        }
      ],
      slider: {
        post_id: null,
        slider_group: "Allnews",
        order_number: null,
        is_active: 1
      },
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newFeaturedImage: {
        featured_id: null,
        cropped: null
      },
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: [],
      err:null
    };
  },
  components: {
    Card,
    ModelSelect
  },

  methods: {
    remove: function(id) {
      this.toggleLoader();
      this.$http.delete("/api/slider/delete/" + id).then(
        response => {
          this.notifier("top", "right", "warning", "Menu elemanı silindi");
          this.getSlider();
          this.toggleLoader();
        },
        e => {
          this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          this.toggleLoader();
        }
      );
    },
    uploadImage: function() {
      this.$http
        .post(
          "/api/images/upload/boxes-under-slider-" + this.newFeaturedImage.id,
          this.newFeaturedImage
        )
        .then(
          response => {
            this.featuredTitles[this.newFeaturedImage.id].image =
              response.body.Data.Response.name;
            this.hideCroppieModal();
            document.getElementById("submit-image").innerHTML = "Kaydet";
            this.toggleLoader();
          },
          e => {
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            this.toggleLoader();
          }
        );
    },
    loadItems: function() {
      this.options = [];
      this.toggleLoader();
      var url = "/api/posts/latest";
      this.$http.get(url).then(
        response => {
          response = response.body;
          for (var i = 0; i < response.length; i++) {
            var temp = { value: response[i].id, text: response[i].name };
            this.options.push(temp);
          }
          this.toggleLoader();
        },
        er => {
          this.notifier(
            "top",
            "right",
            "danger",
            "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
          );
          this.toggleLoader();
        }
      );
    },
    loadFeaturedTitles: function() {
      this.toggleLoader();
      this.$http.get("/api/settings/get-featured-under-slider").then(
        response => {
          var settings = response.body;
          this.featuredTitles = [];
          for (var i = 0; i < settings.length; i++) {
            var jsonData = JSON.parse(settings[i].data);
            jsonData.key = "bellow_slider_" + (i + 1);
            this.featuredTitles.push(jsonData);
          }
          this.toggleLoader();
        },
        er => {
          this.notifier(
            "top",
            "right",
            "danger",
            "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
          );
          this.toggleLoader();
        }
      );
    },
    update: function(id) {
      this.$http.post("/api/slider/edit/", this.sliderItems).then(
        response => {
          this.notifier("top", "right", "success", "Sıralama güncellendi");
        },
        e => {
                                                                                                          if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
        }
      );
    },
    save: function(id) {
      this.toggleLoader();
      this.$http.post("/api/slider/add/Allnews", this.slider).then(
        response => {
          this.getSlider();
          this.toggleLoader();
          this.notifier("top", "right", "success", "Başarılı");
        },
        e => {
          this.toggleLoader();
                                                                                                          if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
        }
      );
    },
    saveSettings: function() {
      this.toggleLoader();
      this.$http.post("/api/settings/edit-bulk/", this.featuredTitles).then(
        response => {
          this.toggleLoader();
          this.notifier("top", "right", "success", "Başarılı");
        },
        e => {
          this.toggleLoader();
                                                                                                          if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
        }
      );
    },
    getSlider: function() {
      this.toggleLoader();
      var url = "/api/slider/all/Allnews";
      this.$http.get(url).then(
        response => {
          this.sliderItems = response.body;
          if (this.sliderItems.length > 0) {
            this.slider.order_number = this.sliderItems[0].order_number + 1;
            this.slider.post_id = 0;
          } else {
            this.slider.order_number = 0;
          }
          this.toggleLoader();
        },
        er => {
                    this.toggleLoader();

if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
        }
      );
    },
    initiateCroppie: function(id) {
      this.newFeaturedImage.id = id;
    },
    toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    },
    bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function(oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    changeButtonText: function() {
      document.getElementById("submit-image").innerHTML =
        "<i class='fas fa-circle-notch fa-spin'></i>";
      this.crop();
    },
    crop() {
      var dis = this;
      this.toggleLoader();
      var color = "#e17d00";
      if (this.newFeaturedImage.id === 0) {
        color = "#dc3545";
      } else if (this.newFeaturedImage.id === 1) {
        color = "#17a2b8";
      }
      return new Promise(resolve => {
        let options = {
          format: "jpeg",
          size: {
            width: 277,
            height: 244
          },
          backgroundColor: color,
          quality: 1
        };
        dis.$refs.main.result(options, output => {
          this.newFeaturedImage.cropped = output;
          this.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result(output) {
      return output;
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getSlider();
      this.loadItems();
      this.loadFeaturedTitles();
    });
  }
};
</script>
<style>
.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: #007bff !important;
}
.nav-pills:focus {
  outline: none;
}
.nav-pills a {
  color: #000;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  color: #fff;
}
.nav-item {
  margin-bottom: 5px;
}
.menu-item:hover {
  cursor: move;
}

.bg-gray {
  background-color: #bdc3c7 !important;
}
textarea.form-control {
  height: 100px;
  border-style: solid !important;
  border-width: 1px !important;
  border-color: rgb(170, 170, 170) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/AllnewsOrderModules/AllnewsOrder.vue